export const TEMPLATE_LIST_REQUEST = 'TEMPLATE_LIST_REQUEST';
export const TEMPLATE_LIST_SUCCESS = 'TEMPLATE_LIST_SUCCESS';
export const TEMPLATE_LIST_FAIL = 'TEMPLATE_LIST_FAIL';

export const TEMPLATE_DETAILS_REQUEST = 'TEMPLATE_DETAILS_REQUEST';
export const TEMPLATE_DETAILS_SUCCESS = 'TEMPLATE_DETAILS_SUCCESS';
export const TEMPLATE_DETAILS_FAIL = 'TEMPLATE_DETAILS_FAIL';

export const TEMPLATE_CREATE_REQUEST = 'TEMPLATE_CREATE_REQUEST';
export const TEMPLATE_CREATE_SUCCESS = 'TEMPLATE_CREATE_SUCCESS';
export const TEMPLATE_CREATE_FAIL = 'TEMPLATE_CREATE_FAIL';

export const TEMPLATE_UPDATE_REQUEST = 'TEMPLATE_UPDATE_REQUEST';
export const TEMPLATE_UPDATE_SUCCESS = 'TEMPLATE_UPDATE_SUCCESS';
export const TEMPLATE_UPDATE_FAIL = 'TEMPLATE_UPDATE_FAIL';

export const TEMPLATE_DELETE_REQUEST = 'TEMPLATE_DELETE_REQUEST';
export const TEMPLATE_DELETE_SUCCESS = 'TEMPLATE_DELETE_SUCCESS';
export const TEMPLATE_DELETE_FAIL = 'TEMPLATE_DELETE_FAIL';

export const TEMPLATE_PREVIEW_REQUEST = 'TEMPLATE_PREVIEW_REQUEST';
export const TEMPLATE_PREVIEW_SUCCESS = 'TEMPLATE_PREVIEW_SUCCESS';
export const TEMPLATE_PREVIEW_FAIL = 'TEMPLATE_PREVIEW_FAIL';

export const GENERIC_TEMPLATE_LIST_REQUEST = 'GENERIC_TEMPLATE_LIST_REQUEST';
export const GENERIC_TEMPLATE_LIST_SUCCESS = 'GENERIC_TEMPLATE_LIST_SUCCESS';
export const GENERIC_TEMPLATE_LIST_FAIL = 'GENERIC_TEMPLATE_LIST_FAIL';

export const GENERIC_TEMPLATE_DETAILS_REQUEST = 'GENERIC_TEMPLATE_DETAILS_REQUEST';
export const GENERIC_TEMPLATE_DETAILS_SUCCESS = 'GENERIC_TEMPLATE_DETAILS_SUCCESS';
export const GENERIC_TEMPLATE_DETAILS_FAIL = 'GENERIC_TEMPLATE_DETAILS_FAIL';

export const GENERIC_TEMPLATE_CREATE_REQUEST = 'GENERIC_TEMPLATE_CREATE_REQUEST';
export const GENERIC_TEMPLATE_CREATE_SUCCESS = 'GENERIC_TEMPLATE_CREATE_SUCCESS';
export const GENERIC_TEMPLATE_CREATE_FAIL = 'GENERIC_TEMPLATE_CREATE_FAIL';

export const GENERIC_TEMPLATE_UPDATE_REQUEST = 'GENERIC_TEMPLATE_UPDATE_REQUEST';
export const GENERIC_TEMPLATE_UPDATE_SUCCESS = 'GENERIC_TEMPLATE_UPDATE_SUCCESS';
export const GENERIC_TEMPLATE_UPDATE_FAIL = 'GENERIC_TEMPLATE_UPDATE_FAIL';

export const GENERIC_TEMPLATE_DELETE_REQUEST = 'GENERIC_TEMPLATE_DELETE_REQUEST';
export const GENERIC_TEMPLATE_DELETE_SUCCESS = 'GENERIC_TEMPLATE_DELETE_SUCCESS';
export const GENERIC_TEMPLATE_DELETE_FAIL = 'GENERIC_TEMPLATE_DELETE_FAIL';

export const SYSTEM_TEMPLATE_LIST_REQUEST = 'SYSTEM_TEMPLATE_LIST_REQUEST';
export const SYSTEM_TEMPLATE_LIST_SUCCESS = 'SYSTEM_TEMPLATE_LIST_SUCCESS';
export const SYSTEM_TEMPLATE_LIST_FAIL = 'SYSTEM_TEMPLATE_LIST_FAIL';

export const SYSTEM_TEMPLATE_LIST_BY_IDS_REQUEST = 'SYSTEM_TEMPLATE_LIST_BY_IDS_REQUEST';
export const SYSTEM_TEMPLATE_LIST_BY_IDS_SUCCESS = 'SYSTEM_TEMPLATE_LIST_BY_IDS_SUCCESS';
export const SYSTEM_TEMPLATE_LIST_BY_IDS_FAIL = 'SYSTEM_TEMPLATE_LIST_BY_IDS_FAIL';
export const SYSTEM_TEMPLATE_LIST_BY_IDS_RESET = 'SYSTEM_TEMPLATE_LIST_BY_IDS_RESET';

export const SYSTEM_TEMPLATE_DETAILS_REQUEST = 'SYSTEM_TEMPLATE_DETAILS_REQUEST';
export const SYSTEM_TEMPLATE_DETAILS_SUCCESS = 'SYSTEM_TEMPLATE_DETAILS_SUCCESS';
export const SYSTEM_TEMPLATE_DETAILS_FAIL = 'SYSTEM_TEMPLATE_DETAILS_FAIL';

export const SYSTEM_TEMPLATE_CREATE_REQUEST = 'SYSTEM_TEMPLATE_CREATE_REQUEST';
export const SYSTEM_TEMPLATE_CREATE_SUCCESS = 'SYSTEM_TEMPLATE_CREATE_SUCCESS';
export const SYSTEM_TEMPLATE_CREATE_FAIL = 'SYSTEM_TEMPLATE_CREATE_FAIL';
export const SYSTEM_TEMPLATE_CREATE_RESET = 'SYSTEM_TEMPLATE_CREATE_RESET';

export const SYSTEM_TEMPLATE_UPDATE_REQUEST = 'SYSTEM_TEMPLATE_UPDATE_REQUEST';
export const SYSTEM_TEMPLATE_UPDATE_SUCCESS = 'SYSTEM_TEMPLATE_UPDATE_SUCCESS';
export const SYSTEM_TEMPLATE_UPDATE_FAIL = 'SYSTEM_TEMPLATE_UPDATE_FAIL';
export const SYSTEM_TEMPLATE_UPDATE_RESET = 'SYSTEM_TEMPLATE_UPDATE_RESET';

export const SYSTEM_TEMPLATE_DELETE_REQUEST = 'SYSTEM_TEMPLATE_DELETE_REQUEST';
export const SYSTEM_TEMPLATE_DELETE_SUCCESS = 'SYSTEM_TEMPLATE_DELETE_SUCCESS';
export const SYSTEM_TEMPLATE_DELETE_FAIL = 'SYSTEM_TEMPLATE_DELETE_FAIL';

export const SYSTEM_TEMPLATE_EXPORT_REQUEST = 'SYSTEM_TEMPLATE_EXPORT_REQUEST';
export const SYSTEM_TEMPLATE_EXPORT_SUCCESS = 'SYSTEM_TEMPLATE_EXPORT_SUCCESS';
export const SYSTEM_TEMPLATE_EXPORT_FAIL = 'SYSTEM_TEMPLATE_EXPORT_FAIL';

export const SYSTEM_TEMPLATE_IMPORT_REQUEST = 'SYSTEM_TEMPLATE_IMPORT_REQUEST';
export const SYSTEM_TEMPLATE_IMPORT_SUCCESS = 'SYSTEM_TEMPLATE_IMPORT_SUCCESS';
export const SYSTEM_TEMPLATE_IMPORT_FAIL = 'SYSTEM_TEMPLATE_IMPORT_FAIL';